import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';

Vue.use(Vuex);

export default new Vuex.Store({
	plugins: [
		createPersistedState({
			paths: ['token']
		})
	],
	modules: {},
	state: {
		token: null,
		loadingContent: false
	},
	mutations,
	actions,
	getters
});
